import React from 'react'
import "./styleSuspendpermissionPopup.css";
import { useDispatch, useSelector } from 'react-redux';
import { setIsSuspendPopup } from '../../../features/pools/poolsSlice';

function INCSUBSuspendPermissionPopup({ fun, memberList, suspendData, type='User' }) {
    const refundData = useSelector((state) => state.pools.refundData);
    const dispatch = useDispatch();
    return (
        <div className='INCSUBSuspendPermissionPopup'>
            <div className='INCSUBPermissionContainer'>
                <div className='INCSUBPermission_head'>
                    <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="49.5434" cy="46.0883" r="32.0883" fill="#FF6565" />
                        <circle cx="14.2399" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                        <circle cx="93.6338" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                        <ellipse cx="4.39875" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                        <circle cx="35.2389" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                        <circle cx="85.7604" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                        <circle cx="89.6969" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                        <circle cx="56.8893" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                        <path d="M48.011 51.7008L46.4619 32H52.5787L51.0296 51.7008H48.011ZM46.74 60.0022V54.4812H52.3007V60.0022H46.74Z" fill="white" />
                    </svg>
                    <h1>Are you sure you want to suspend the Pool {suspendData?.type!=="Host"?"Member":"Host"}?</h1>
                    <p>If you proceed, you will be required to refund the following amount to the pool member{suspendData?.type!=="Host"?"":"s"}.</p>
                </div>
                <hr className='splitter'></hr>
                <div className='INCSUBPermission_list'>
                    {
                        refundData && refundData.length > 0 && refundData.map((member) => <div className='INCSUBMemberList_li'>
                            <div className='INCSUBmemberInfo_container'>
                                <img src={member.userImage ? member.userImage : '/assets/icons/common/defaultImage.png'} alt='/' />
                                <p>{member.userFullName}</p>
                            </div>
                            <div className='INCSUBRefundRupees'>₹ {member?.refundAmount}</div>
                        </div>)
                    }

                </div>
                <div className='INCSUBButtonsContainer'>
                    <div className='INCSUBButton _cancel' onClick={() => dispatch(setIsSuspendPopup(false))}>No</div>
                    <div className='INCSUBButton _suspend' onClick={() => fun(suspendData.poolId, suspendData.userId, true)}>Yes, Suspend</div>
                </div>
            </div>
        </div>
    )
}

export default INCSUBSuspendPermissionPopup
